<template>
    <div class="row">
        <div class="col-12">
            <div v-html="text" class="block-text" v-if="text"></div>
        </div>
        <div class="col-12 block-text">
            <prompt-container
                :prompt="prompt"
                :type="prompt.type"
                :prompt-id="promptId"
                :page-id="pageId"
                :module-id="moduleId"
                :course-id="courseId"
                :course-name="courseName"
                :is-mission="isMission"
                :is-dark-bg="isDarkBg"
                :is-augmented="isAugmented"
            />
        </div>
    </div>
</template>

<script>
import PromptContainer from "../PromptContainer";

export default {
    name: "SinglePrompt",
    components:{PromptContainer},
    props:{
        header: Object,
        text: String,
        prompt: Object,
        promptId: String,
        pageId: String,
        moduleId: Number,
        courseId: Number,
        courseName: String,
        isMission: String,
        isDarkBg: Boolean,
        isAugmented: Boolean
    }
}
</script>

<style scoped>

</style>
